/** @format */
import { css } from 'styled-components';

import { GridItemContainerProps } from './index';

/**
 * Base styles for the GridItemRepeater component
 *
 * @param {GridItemContainerProps} props The GridItemRepeater properties object
 * */
const baseStyles = ({ row, column }: GridItemContainerProps) => css`
    -ms-grid-row: ${row};
    -ms-grid-column: ${column};
`;

/**
 * The card repeater component styles
 *
 * @param {GridItemContainerProps} props The GridItemRepeater properties object
 * */
export const styles = (props: GridItemContainerProps) => css`
    ${baseStyles(props)}
`;
